import React, { useState, useContext, useEffect } from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";
import { useEditPanelContext } from "./edit_panel_context.js";
import { iconMapping } from "../../../components/fileTypeNames.js";
import * as api from "../../../api/apiConnector.js";
import UserContext from "../../../components/User_Context.js";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Choices from "../../../components/Choices.js";

function LinkedFilesTab({linkedFilesManager, item, CanIEditLinkedFile = false }) {
  const { t } = useTranslation("labels");
  const { linkedFiles, setLinkedFiles, loadLinkedFiles } = linkedFilesManager || {};
  const { filesLinkedToThis = [], filesLinkedFromThis = [] } = linkedFiles || {};
  const { currentUser } = useContext(UserContext);

  // Pagination state for each table
  const [currentPageToThis, setCurrentPageToThis] = useState(1);
  const [currentPageFromThis, setCurrentPageFromThis] = useState(1);
  const itemsPerPage = 5;

  // Reset pagination when files change
  useEffect(() => {
    setCurrentPageToThis(1);
  }, [filesLinkedToThis.length]);

  useEffect(() => {
    setCurrentPageFromThis(1);
  }, [filesLinkedFromThis.length]);

  // Helper function to format file size
  const formatFileSize = (fileSize) => {
    if (!fileSize) return "N/A";
    if (fileSize < 1024) {
      return `${fileSize} bytes`;
    } else if (fileSize >= 1024 && fileSize < 1048576) {
      const kbValue = fileSize / 1024;
      return `${Math.round(kbValue.toFixed(2))} KB`;
    } else if (fileSize >= 1048576 && fileSize < 1073741824) {
      const mbValue = fileSize / 1024 / 1024;
      return `${Math.round(mbValue.toFixed(2))} MB`;
    } else {
      const gbValue = fileSize / 1024 / 1024 / 1024;
      return `${Math.round(gbValue.toFixed(2))} GB`;
    }
  };

  // Helper function to format date
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString();
    } catch (error) {
      return "N/A";
    }
  };


  // Create file search Choices component
  const createFileSearchChoices = () => {
    const _selected = [];

    return (
      <div>
        {t("addNewLinkedFileDescription", { ns: "labels" })}
        <Choices
          voc={_selected}
          multiple={true}
          dropDownParent={"add-linked-file-modal"}
          value={"Id"}
          text={"Name"}
          selected={_selected}
          minText={2}
          maxItemLength={300}
          textDelegate={(item) => {
            const fileName = item.Name || "N/A";
            let pathText = "";
            
            if (item?.Path?.Path && item.Path.Path.length > 0) {
              // Map all path parts with " / " separator, matching the example format
              const pathParts = item.Path.Path.map((x, index) => {
                if (index === 0) {
                  return x.Name;
                } else {
                  return ` / ${x.Name}`;
                }
              });
              pathText = `in ${pathParts.join("")}`;
            }
            
            // Return HTML string for Select2 to render
            return pathText ? `${fileName}<br><small style="color: #6c757d;">${pathText}</small>` : fileName;
          }}
          onChange={(e) => {
            // Store selected files
            window.selectedLinkedFiles = e.selected.map((file) => ({
              id: file.Id,
              data: file,
            }));

            // Update add button state
            window
              .$("#addSelectedLinkedFiles")
              .prop("disabled", window.selectedLinkedFiles.length === 0);
          }}
          remoteSource={async ({ text }) => {
            if (!text || text.length < 2) {
              return [];
            }

            try {
              const result = await api.sendMessage(
                "dms/reducedSearchFileForLinkedFiles",
                {
                  user: currentUser(),
                  body: {
                    text: text,
                  },
                }
              );

              return result?.data ?? result?.files ?? [];
            } catch (error) {
              console.error("File search error:", error);
              return [];
            }
          }}
        ></Choices>
      </div>
    );
  };

  // Handle open add linked file modal
  const handleOpenAddLinkedFileModal = () => {
    const addLinkedFileModalHtml = `
      <div id="add-linked-file-modal" class="modal fade" tabIndex="-1" aria-labelledby="addLinkedFileModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="addLinkedFileModalLabel">${t("addNewLinkedFile", { ns: "labels" })}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class='add-linked-files-choices'>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                ${t("close", { ns: "labels" }) || "Close"}
              </button>
              <button type="button" class="btn btn-primary" id="addSelectedLinkedFiles" disabled>
                ${t("addSelected", { ns: "labels" }) || "Add Selected"}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Remove existing modal and add new one
    window.$("#add-linked-file-modal").remove();
    window.$("body").append(addLinkedFileModalHtml);

    const addModal = window.$("#add-linked-file-modal");
    
    // Populate modal body with Choices component
    const modalBodyContainer = window.$(".add-linked-files-choices");
    const choicesComponent = createFileSearchChoices();

    // Render the JSX component using ReactDOM
    const root = ReactDOM.createRoot(modalBodyContainer[0]);
    root.render(choicesComponent);

    // Initialize selected files
    window.selectedLinkedFiles = [];

    // Handle add selected button
    window
      .$("#addSelectedLinkedFiles")
      .off("click")
      .on("click", async function () {
        if (
          window.selectedLinkedFiles &&
          window.selectedLinkedFiles.length > 0
        ) {
          // TODO: Implement add linked files logic

          //qui dammi solo un array di id dei files selezioanti
          const selectedFileIds = window.selectedLinkedFiles.map((file) => file.id);

          const result = await api.sendMessage("dms/saveLinkedFiles", {
            user: currentUser(),
            body: {
              fileIds: selectedFileIds,
              mainFileId: item.item.Id,
            },
          });
          if (result?.success) {
            //aggiorna la tabella dei files collegati a questo
            if (loadLinkedFiles && item?.item?.Id) {
              await loadLinkedFiles(item.item.Id);
            }
            withReactContent(Swal).fire({
              title: t("success", { ns: "labels" }) || "Success",
              icon: "success",
              text: t("linkedFilesAdded", { ns: "labels" }) || "Linked files added successfully",
              showConfirmButton: true,
            });
          } else {
            withReactContent(Swal).fire({
              title: t("error", { ns: "labels" }),
              icon: "error",
              text: result?.message || t("linkedFilesAddError", { ns: "labels" }) || "Error adding linked files",
              showConfirmButton: true,
            });
          }
          addModal.modal("hide");
        }
      });

    addModal.modal("show");
  };

  // Handle remove linked file
  const handleRemoveLinkedFile = async (file, event) => {
    // Prevent row click event
    if (event) {
      event.stopPropagation();
    }

    const confirmText = t("removeLinkedFileConfirm", { ns: "labels" }) || "Are you sure you want to remove the link to \"{fileName}\"?";
    const confirmTextWithFileName = confirmText.replace("{fileName}", file.Name || "N/A");

    const result = await withReactContent(Swal).fire({
      title: t("removeLinkedFile", { ns: "labels" }) || "Remove Linked File",
      text: confirmTextWithFileName,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: t("yes", { ns: "labels" }) || "Yes",
      cancelButtonText: t("no", { ns: "labels" }) || "No",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    });

    if (result.isConfirmed) {
      try {
        const removeResult = await api.sendMessage("dms/removeLinkedFile", {
          user: currentUser(),
          body: {
            mainFileId: item?.item?.Id,
            linkedFileId: file.Id,
          },
        });

        if (removeResult?.success) {
          // Reload linked files to update the table
          if (loadLinkedFiles && item?.item?.Id) {
            await loadLinkedFiles(item.item.Id);
          }
          withReactContent(Swal).fire({
            title: t("success", { ns: "labels" }) || "Success",
            icon: "success",
            text: t("linkedFileRemoved", { ns: "labels" }) || "Linked file removed successfully",
            showConfirmButton: true,
          });
        } else {
          withReactContent(Swal).fire({
            title: t("error", { ns: "labels" }),
            icon: "error",
            text: removeResult?.message || t("linkedFileRemoveError", { ns: "labels" }) || "Error removing linked file",
            showConfirmButton: true,
          });
        }
      } catch (error) {
        console.error("Error removing linked file:", error);
        withReactContent(Swal).fire({
          title: t("error", { ns: "labels" }),
          icon: "error",
          text: t("linkedFileRemoveError", { ns: "labels" }) || "Error removing linked file",
          showConfirmButton: true,
        });
      }
    }
  };

  // Handle file download
  const handleFileDownload = async (file) => {
    try {
      const fileBlob = await api.downloadFileGet(
        `dms/wopi/content?id=${file.Id}`,
        {
          user: currentUser(),
        }
      );

      if (fileBlob && fileBlob.success === undefined) {
        // Create download link and trigger download
        const url = window.URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = file.Name || `file_${file.Id}`;
        document.body.appendChild(link);
        link.click();

        // Cleanup
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        withReactContent(Swal).fire({
          title: t("error", { ns: "labels" }),
          icon: "error",
          text: fileBlob?.message || t("downloadError", { ns: "labels" }),
          showConfirmButton: true,
        });
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      withReactContent(Swal).fire({
        title: t("error", { ns: "labels" }),
        icon: "error",
        text: t("downloadError", { ns: "labels" }),
        showConfirmButton: true,
      });
    }
  };

  // Pagination helper functions
  const getPagedNumbers = (currentPage, totalPages) => {
    let maxButtons = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
    let endPage = Math.min(totalPages, startPage + maxButtons - 1);

    // Adjust if we are at the end to ensure we still show 5 buttons if possible
    if (endPage - startPage + 1 < maxButtons) {
      startPage = Math.max(1, endPage - maxButtons + 1);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  // Render pagination controls
  const renderPagination = (currentPage, totalPages, handlePageChange) => {
    if (totalPages <= 1) return null;

    return (
      <nav aria-label="Table pagination" className="mt-3 pb-1">
        <ul className="pagination justify-content-center">
          {/* First Page Button */}
          {currentPage > 4 && (
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              >
                &laquo;&laquo;
              </button>
            </li>
          )}

          {/* Previous Button */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              &laquo;
            </button>
          </li>

          {/* Dynamic Page Numbers */}
          {getPagedNumbers(currentPage, totalPages).map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            </li>
          ))}

          {/* Next Button */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              &raquo;
            </button>
          </li>

          {/* Last Page Button */}
          {currentPage < totalPages - 3 && (
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              >
                &raquo;&raquo;
              </button>
            </li>
          )}
        </ul>
      </nav>
    );
  };

  // Render file table
  const renderFileTable = (files, emptyMessage, currentPage, setCurrentPage, showDeleteButton = false) => {
    // Pagination calculations
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = files.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(files.length / itemsPerPage);
    const fillerRowCount = Math.max(0, itemsPerPage - currentItems.length);

    if (!files || files.length === 0) {
      return (
        <div
          className="w-80 border overflow-hidden"
          style={{
            borderRadius: "12px",
            borderColor: "#dee2e6",
            borderStyle: "solid",
            borderWidth: "1px",
          }}
        >
          <table className="table table-striped table-hover mb-0">
            <thead className="bg-white">
              <tr>
                <th scope="col" className="py-3 ps-4">
                  {t("fileName", { ns: "labels" })}
                </th>
                {showDeleteButton && (
                  <th scope="col" className="py-3 text-center" style={{ width: "60px" }}>
                    {t("actions", { ns: "labels" }) || "Actions"}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: itemsPerPage }).map((_, idx) => (
                <tr key={`empty-${idx}`}>
                  {idx === Math.floor(itemsPerPage / 2) ? (
                    <td colSpan={showDeleteButton ? 2 : 1} className="ps-4 text-muted text-center">
                      {emptyMessage}
                    </td>
                  ) : (
                    <>
                      <td className="ps-4">&nbsp;</td>
                      {showDeleteButton && <td>&nbsp;</td>}
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }

    return (
      <>
        <div
          className="w-80 border overflow-hidden"
          style={{
            borderRadius: "12px",
            borderColor: "#dee2e6",
            borderStyle: "solid",
            borderWidth: "1px",
          }}
        >
          <table className="table table-striped table-hover mb-0">
            <thead className="bg-white">
              <tr>
                <th scope="col" className="py-3 ps-4">
                  {t("fileName", { ns: "labels" })}
                </th>
                {showDeleteButton && (
                  <th scope="col" className="py-3 text-center" style={{ width: "60px" }}>
                    {t("actions", { ns: "labels" }) || "Actions"}
                  </th>
                )}
                {/* <th scope="col" className="py-3">
                  {t("fileType", { ns: "labels" })}
                </th> */}
                {/* <th scope="col" className="py-3">
                  {t("size", { ns: "labels" })}
                </th>
                <th scope="col" className="py-3">
                  {t("lastUpdate", { ns: "labels" })}
                </th> */}
              </tr>
            </thead>
            <tbody>
              {currentItems.map((file) => (
                <tr
                  key={file.Id}
                  onClick={() => handleFileDownload(file)}
                  style={{
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = "#f8f9fa";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = "";
                  }}
                >
                  <td 
                    className="ps-4"
                    style={{
                      maxWidth: "300px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                    title={file.Name || "N/A"}
                  >
                    {file.Name || "N/A"}
                  </td>
                  {showDeleteButton && (
                    <td 
                      className="text-center"
                      onClick={(e) => handleRemoveLinkedFile(file, e)}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <i 
                        className="fa-solid fa-trash text-danger"
                        title={t("removeLinkedFile", { ns: "labels" }) || "Remove linked file"}
                        style={{
                          fontSize: "16px",
                        }}
                      ></i>
                    </td>
                  )}
                  {/* <td>{file.MimeType ? iconMapping(file.MimeType) : "N/A"}</td> */}
                  {/* <td>{formatFileSize(file.FileSize)}</td>
                  <td>{formatDate(file.ItemLastUpdated)}</td> */}
                </tr>
              ))}
              {Array.from({ length: fillerRowCount }).map((_, idx) => (
                <tr key={`filler-${idx}`}>
                  <td className="ps-4">&nbsp;</td>
                  {showDeleteButton && <td>&nbsp;</td>}
                  {/* <td>&nbsp;</td> */}
                  {/* <td>&nbsp;</td>
                  <td>&nbsp;</td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {renderPagination(currentPage, totalPages, setCurrentPage)}
      </>
    );
  };

  return (
    <div className="container-fluid mx-auto py-0 h-80 d-flex flex-column pt-4 overflow-hidden">
      {/* Files Linked To This Section */}
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0">{t("filesLinkedToThis", { ns: "labels" })}</h5>
          {CanIEditLinkedFile && (
            <button
              className="btn btn-sm btn-primary"
              onClick={handleOpenAddLinkedFileModal}
              style={{
                minWidth: "32px",
                height: "32px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 0,
              }}
              title={t("addNewLinkedFile", { ns: "labels" })}
            >
              <i className="fa-solid fa-plus"></i>
            </button>
          )}
        </div>
        <div className="flex-grow-1 shadow" style={{ borderRadius: "12px" }}>
          {renderFileTable(
            filesLinkedToThis,
            t("noFilesLinkedToThis", { ns: "labels" }),
            currentPageToThis,
            setCurrentPageToThis,
            CanIEditLinkedFile // showDeleteButton
          )}
        </div>
      </div>

      {/* Files Linked From This Section */}
      <div className="mb-4">
        <h5 className="mb-3">{t("filesLinkedFromThis", { ns: "labels" })}</h5>
        <div className="flex-grow-1 shadow" style={{ borderRadius: "12px" }}>
          {renderFileTable(
            filesLinkedFromThis,
            t("noFilesLinkedFromThis", { ns: "labels" }),
            currentPageFromThis,
            setCurrentPageFromThis
          )}
        </div>
      </div>
    </div>
  );
}

export default LinkedFilesTab;
